<template>
	<div>
		<div class="d-flex justify-content-around">
			<circle-loader/>
		</div>
	</div>
</template>

<script>
	import CircleLoader from './CircleLoader';

	export default {
		components: {CircleLoader},
		name: 'LoadingSpinner',
		data() {
			return {};
		},
		computed: {},
		beforeCreate() {
		},
		mounted() {
		},
		methods: {}
	};
</script>

<style scoped lang="scss">
	@import '../../styles/scss/colors';

	svg {
		height: 25px;
		width: 25px;
	}

	.ellipsis-anim span {
		opacity: 0;
		margin-left: 5px;
		position: relative;
		top: 1px;
		left: 5px;
		color: $purple;
		-webkit-animation: ellipsis-dot 1s infinite;
		animation: ellipsis-dot 1s infinite;
	}

	.ellipsis-anim span:nth-child(1) {
		-webkit-animation-delay: 0.0s;
		animation-delay: 0.0s;
	}

	.ellipsis-anim span:nth-child(2) {
		-webkit-animation-delay: 0.1s;
		animation-delay: 0.1s;
	}

	.ellipsis-anim span:nth-child(3) {
		-webkit-animation-delay: 0.2s;
		animation-delay: 0.2s;
	}

	@-webkit-keyframes ellipsis-dot {
		0% {
			opacity: 0;
		}
		50% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}

	@keyframes ellipsis-dot {
		0% {
			opacity: 0;
		}
		50% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}
</style>
